import React from 'react'
import Modal from './Modal'
import Sidebar from './Sidebar'
import Home from './Home'
function App() {
  return (
    <>
     <Home/>
      <Sidebar/>
      <Modal/>
    </>
  )
}

export default App
